import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React from 'react';

interface VisualWithDetailsProps {
  title: string;
  children: React.ReactNode;
  visual?: JSX.Element;
  testId?: string;
}

export const VisualWithDetails: React.FC<VisualWithDetailsProps> = ({
  visual,
  title,
  children,
  testId,
}) => {
  const {hasDarkBg} = useThemeContext();

  return (
    <div className="flex w-full md:flex-col">
      <div className={classNames('md:w-full', visual && 'w-1/5')}>{visual}</div>
      <div className={classNames('my-auto md:w-full', visual && 'ml-4 w-4/5 md:ml-0')}>
        <p
          data-testid={testId !== undefined ? `visual-with-details-title-${testId}` : ''}
          className={classNames(
            'w-full font-semibold md:w-full md:text-left md:text-2xl',
            visual && 'md:mt-7',
            hasDarkBg ? 'text-white' : 'text-black/90'
          )}
        >
          {title}
        </p>

        <div data-testid={testId !== undefined ? `visual-with-details-details-${testId}` : ''}>
          {children}
        </div>
      </div>
    </div>
  );
};

VisualWithDetails.displayName = 'VisualWithDetails';
